/** Arabic UI strings — same keys as `fr.js`. */
export default {
  nav: {
    dashboard: 'لوحة القيادة',
    courses: 'الدورات',
    groups: 'المجموعات',
    students: 'الطلاب',
    trainers: 'المدربون',
    sessions: 'الجلسات',
    certifications: 'الشهادات',
    evaluations: 'التقييمات',
    schedule: 'الجدول الزمني',
    classrooms: 'القاعات',
    payments: 'المدفوعات',
    benefits: 'الأرباح',
    reports: 'التقارير',
    settings: 'الإعدادات',
  },

  layout: {
    logout: 'تسجيل الخروج',
    menuTitle: 'القائمة',
    menuCloseSr: 'إغلاق',
    mainNavAria: 'التنقل الرئيسي',
    overlayCloseNav: 'إغلاق القائمة',
    mobileNavPrimary: 'التنقل الرئيسي',
  },

  header: {
    brandLine: 'مدرسة تكوين',
    searchPlaceholder: 'ابحث عن صفحة، دورة، طالب…',
    searchSrOnly: 'بحث',
    openMenuSr: 'فتح القائمة',
    toggleMenuSr: 'تبديل القائمة',
    themeLightAria: 'التبديل إلى الوضع الفاتح',
    themeDarkAria: 'التبديل إلى الوضع الداكن',
    changeLangAria: 'تغيير اللغة',
    notificationsSr: 'الإشعارات',
    notificationsTitle: 'الإشعارات',
    notificationsCloseBackdrop: 'إغلاق الإشعارات',
    notificationsEmpty: 'لا توجد إشعارات',
    userMenuSr: 'قائمة المستخدم',
    closeUserMenu: 'إغلاق قائمة المستخدم',
    fallbackUserName: 'مستخدم',
    fallbackUserRole: 'مدير',
  },

  login: {
    title: 'تسجيل الدخول',
    formSubtitle: 'ادخل إلى مساحة إدارة التكوين الخاصة بك.',
    emailLabel: 'البريد الإلكتروني',
    passwordLabel: 'كلمة المرور',
    submit: 'تسجيل الدخول',
    loading: 'جاري الاتصال…',
    errorGeneric: 'تعذر تسجيل الدخول. تحقق من بياناتك أو أعد المحاولة لاحقاً.',
    platformLabel: 'منصة التكوين',
    heroTitle: 'أدِر مدرستك التكوينية بكل سهولة',
    heroSubtitle: 'الدورات، التسجيلات، المدفوعات والتقارير — كل شيء في أداة واحدة.',
    feature_courses: 'إدارة الدورات والمجموعات',
    feature_reports: 'متابعة مالية وتقارير فورية',
    feature_secure: 'وصول آمن مخصص للطاقم',
    secureAccess: 'وصول آمن للطاقم',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    footerNote: 'مخصص للطاقم المخوّل في المؤسسة.',
    trustBadge: 'مساحة آمنة · طاقم مخوّل',
  },

  dashboard: {
    title: 'لوحة القيادة',
    description: 'نظرة عامة على النشاط التعليمي والإيرادات وإشغال القاعات.',
    newCourse: 'دورة جديدة',
    statStudents: 'طلاب نشطون',
    statCourses: 'دورات جارية',
    statRevenue: 'إيرادات الشهر',
    statOccupancy: 'معدل الإشغال',
    seeDetails: 'عرض التفاصيل ←',
    chartDistributionTitle: 'التوزيع حسب نوع التكوين',
    allCoursesLink: 'كل الدورات',
    shareOfCourses: '{pct}% من التكوينات',
    revenueTitle: 'الإيرادات الشهرية',
    benefitsLink: 'الأرباح',
    montantLegend: 'المبلغ',
    pieDistributionTitle: 'توزيع التكوينات',
    manageCourses: 'إدارة الدورات',
    coursesCount: '{n} دورات',
    countLegend: 'العدد',
    upcomingTitle: 'الدورات القادمة',
    upcomingSubtitle: 'الجلسات المجدولة',
    seeAll: 'عرض الكل',
    loadingCourses: 'جاري تحميل الدورات…',
    emptyUpcomingTitle: 'لا توجد دورات قادمة',
    emptyUpcomingBody: 'جدول جلسة من الدورات أو الجدولة لعرضها هنا.',
    scheduleCourse: 'جدولة دورة',
    colCourse: 'الدورة',
    colStartDate: 'تاريخ البداية',
    colStudents: 'الطلاب',
    colRoom: 'القاعة',
    colActions: 'إجراءات',
    viewDetails: 'عرض التفاصيل',
    occupancyTitle: 'الإشغال الأسبوعي للقاعات',
    manageRooms: 'إدارة القاعات',
    occupancyLegend: 'معدل الإشغال',
    noCourseData: 'لا توجد بيانات',
    noTitleCourse: 'دورة بلا عنوان',
    undefinedRoom: 'قاعة غير محددة',
    weekdaysShort: ['إثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت', 'أحد'],
    monthsFallback: ['ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون', 'يول'],
    currencyDa: 'دج',
    pieTooltipCourses: '{n} دورات',
    quickActions: 'وصول سريع',
    revenueSubtitle: 'تطور الإيرادات خلال الفترة',
    pieSubtitle: 'توزيع التكوينات النشطة',
    occupancySubtitle: 'متابعة استخدام القاعات أسبوعياً',
    studentsShort: 'طالب',
  },

  settingsPage: {
    title: 'الإعدادات',
    description: 'إعدادات المؤسسة والدورات والقاعات والفوترة.',
    sections: 'الأقسام',
    resources: 'الموارد',
    mobileApp: 'التطبيق',
    languages: 'اللغات',
    helpCenter: 'مركز المساعدة',
    helpGuide: 'دليل الاستخدام',
    contactSupport: 'الاتصال بالدعم',
    tabGeneral: 'عام',
    tabNotifications: 'الإشعارات',
    tabSecurity: 'الأمان',
    tabHours: 'المواعيد',
    tabBilling: 'الفوترة',
    tabCourses: 'الدورات',
    tabClassrooms: 'القاعات',
    tabTrainers: 'المدربون',
    tabCertifications: 'الشهادات',
    tabGeneralDesc: 'هوية المؤسسة والاتصال والشعار',
    tabNotificationsDesc: 'تنبيهات البريد والتذكيرات التلقائية',
    tabSecurityDesc: 'الجلسات وكلمات المرور والمصادقة',
    tabHoursDesc: 'ساعات عمل المؤسسة',
    tabBillingDesc: 'الضريبة والفواتير وشروط الدفع',
    tabCoursesDesc: 'اختصار لإدارة الدورات',
    tabClassroomsDesc: 'اختصار لإدارة القاعات',
    tabTrainersDesc: 'عمولة المدربين (تُستخدم في المزايا والتقارير)',
    tabCertificationsDesc: 'قوالب PDF المستخدمة في صفحة الشهادات',
    moduleRedirectNoticeTitle: 'يُدار في مكان آخر',
    coursesRedirectTitle: 'الدورات والبرامج',
    coursesRedirectDesc: 'تُنشأ الدورات والأسعار والمجموعات من صفحة الدورات — وليس هنا.',
    coursesRedirectLink: 'فتح صفحة الدورات',
    coursesRedirectNotice: 'يوجّهك هذا التبويب إلى الوحدة الرئيسية. البيانات السابقة هنا كانت أمثلة ثابتة غير محفوظة.',
    coursesBullet1: 'إنشاء وتعديل الدورات',
    coursesBullet2: 'تحديد الأسعار والمجموعات',
    coursesBullet3: 'تعيين المدربين والقاعات',
    classroomsRedirectTitle: 'القاعات والمعدات',
    classroomsRedirectDesc: 'قائمة القاعات والسعة والمعدات تُدار من صفحة القاعات.',
    classroomsRedirectLink: 'فتح صفحة القاعات',
    classroomsRedirectNotice: 'أنواع القاعات السابقة لم تكن تُحفظ. استخدم صفحة القاعات للبيانات الفعلية.',
    classroomsBullet1: 'إضافة وتعديل القاعات',
    classroomsBullet2: 'السعة ونوع القاعة',
    classroomsBullet3: 'المعدات المتاحة',
    trainersCommissionNoticeTitle: 'عمولة نشطة',
    trainersCommissionNotice: 'تُستخدم هذه النسبة فوراً في المزايا والتقارير لحساب حصة المدرب والمؤسسة.',
    trainersCommissionTitle: 'عمولة المدربين',
    trainersCommissionLabel: 'النسبة المخصصة للمدربين',
    trainersCommissionHint: 'تُطبَّق تلقائياً على الحسابات المالية.',
    trainersCommissionInvalid: 'يجب أن تكون النسبة بين 0 و 100',
    trainersCommissionUpdated: 'تم تحديث العمولة: {{rate}}%',
    trainersCommissionPreview: 'معاينة على دفعة 55 000 د.ج',
    trainersPreviewPayment: 'دفعة الطالب',
    trainersPreviewTrainer: 'حصة المدرب ({{rate}}%)',
    trainersPreviewSchool: 'حصة المؤسسة ({{rate}}%)',
    trainersManageTitle: 'الملفات والتخصصات',
    trainersManageDesc: 'بيانات المدربين والتخصصات والتعيينات تُدار من صفحة المدربين.',
    trainersManageLink: 'فتح المدربين',
  },

  trainersPage: {
    title: 'المدربون',
    description: 'إدارة المدربين والدورات المرتبطة بهم.',
    newTrainer: 'مدرب جديد',
    statTotal: 'إجمالي المدربين',
    statTotalHint: 'في دليلك',
    statCourses: 'دورات مخصصة',
    statCoursesHint: 'ارتباط تكوين–مدرب',
    statSpecs: 'التخصصات',
    statSpecsHint: 'مجالات مميزة',
    allSpecialties: 'كل التخصصات',
    specialityLabel: 'التخصص',
    filterCountHint: 'العدد بعد البحث',
    searchSr: 'ابحث عن مدرب',
    searchPlaceholder: 'الاسم، البريد أو التخصص…',
    clearSearchAria: 'مسح البحث',
    filtersActive: 'عوامل التصفية النشطة',
    resetFilters: 'إعادة الضبط',
    selectedSingle: 'مدرب واحد مختار',
    selectedPlural: '{n} مدربين مختارين',
    deselectAll: 'إلغاء التحديد الكل',
    deleteSelected: 'حذف ({n})',
    emptyTitle: 'لا يوجد مدربون للعرض',
    emptyBody:
      'جرّب بحثًا آخر، أو وسّع التصفية ثم إعادة الضبط، أو أضف مدربًا جديدًا.',
    clearFiltersBtn: 'مسح التصفية والبحث',
    addTrainer: 'إضافة مدرب',
    listHeading: 'قائمة المدربين',
    resultsSingular: 'نتيجة',
    resultsPlural: 'نتائج',
    rangeOn: 'النطاق',
    onTotal: 'من',
    perPage: 'لكل صفحة',
    srSelection: 'تحديد',
    selectPageAria: 'تحديد الكل في هذه الصفحة',
    colTrainer: 'المدرب',
    colContact: 'جهة الاتصال',
    colSpecialty: 'التخصص',
    colAssignedCourses: 'الدورات المخصصة',
    colActions: 'إجراءات',
    experienceYearsSingular: 'سنة خبرة',
    experienceYearsPlural: 'سنوات خبرة',
    notSpecified: 'غير محدد',
    noAssignedCourses: 'لا توجد دورات مخصصة',
    selectTrainerSr: 'تحديد {name}',
    titleView: 'عرض التفاصيل',
    titleEdit: 'تعديل',
    titleDelete: 'حذف',
    paginationLabel: 'ترقيم الصفحات',
    prev: 'السابق',
    next: 'التالي',
    paginationSummary:
      'عرض {range} من {total} · صفحة {page} من {pages}',
    backToList: 'العودة إلى القائمة',
    loading: 'جاري التحميل…',
    confirmDeleteTrainer: 'هل تريد حذف هذا المدرب بالتأكيد؟',
    deleteErrorGeneric: 'حدث خطأ أثناء الحذف',
    bulkDeleteError: 'حدث خطأ أثناء حذف المدربين',
    bulkDeleteTitle: 'تأكيد الحذف',
    bulkDeleteAskOne: 'هل تريد حذف هذا المدرب بالتأكيد؟ لا يمكن التراجع عن هذا الإجراء.',
    bulkDeleteAskMany: 'هل تريد حذف {n} مدربًا بالتأكيد؟ لا يمكن التراجع عن هذا الإجراء.',
  },

  studentsPage: {
    description: 'إدارة الطلاب وتسجيلاتهم',
    newStudent: 'طالب جديد',
    statRegisteredTitle: 'الطلاب المسجلون',
    statRegisteredHint: 'بطاقة مُنشأة في النظام',
    statActiveTitle: 'نشطون',
    statActiveHint: 'الحالة «نشط»',
    statNoCourseTitle: 'دون تكوين',
    statNoCourseHint: 'لا تكوين مرتبط بالبطاقة',
    tabAll: 'كل الطلاب',
    tabActive: 'نشطون',
    tabSuspended: 'معلقون',
    tabInactive: 'غير نشطين',
    tabNoCourse: 'دون تكوين',
    statusLabel: 'الحالة',
    countAfterSearch: 'العدد بعد البحث',
    searchSrOnly: 'ابحث عن طالب',
    searchPlaceholder: 'الاسم، الرمز أو البريد…',
    clearSearchAria: 'مسح البحث',
    filtersActive: 'عوامل التصفية النشطة',
    resetFilters: 'إعادة الضبط',
    selectedSingle: 'طالب واحد مختار',
    selectedPlural: '{n} طلاب مختارون',
    deselectAll: 'إلغاء التحديد الكل',
    deleteSelected: 'حذف ({n})',
    emptyTitle: 'لا يوجد طلاب للعرض',
    emptyBody:
      'جرّب بحثًا آخر، أو وسّع تصفية الحالة ثم إعادة الضبط، أو أنشئ بطاقة طالب.',
    clearFiltersBtn: 'مسح التصفية والبحث',
    addStudent: 'إضافة طالب',
    listHeading: 'قائمة الطلاب',
    resultsSingular: 'نتيجة',
    resultsPlural: 'نتائج',
    rangeOn: 'النطاق',
    onTotal: 'من',
    perPage: 'لكل صفحة',
    srSelection: 'تحديد',
    selectAllPageAria: 'تحديد الكل في هذه الصفحة',
    colStudent: 'الطالب',
    colContact: 'جهة الاتصال',
    colFormation: 'التكوين',
    colStatus: 'الحالة',
    colActions: 'إجراءات',
    noEnrollment: 'دون تسجيل',
    groupNotFound: 'المجموعة غير موجودة',
    enrollmentsCount: '{n} تسجيلات',
    multipleEnrollments: 'تسجيلات متعددة',
    statusActiveLbl: 'نشط',
    statusSuspendedLbl: 'معلق',
    statusInactiveLbl: 'غير نشط',
    selectStudentSr: 'تحديد {name}',
    confirmDeleteStudent: 'هل تريد حذف هذا الطالب بالتأكيد؟',
    deleteErrorGeneric: 'حدث خطأ أثناء الحذف',
    bulkDeleteError: 'حدث خطأ أثناء حذف الطلاب',
    bulkDeleteTitle: 'تأكيد الحذف',
    bulkDeleteAskOne: 'هل تريد حذف هذا الطالب بالتأكيد؟ لا يمكن التراجع.',
    bulkDeleteAskMany: 'هل تريد حذف {n} طلابًا بالتأكيد؟ لا يمكن التراجع.',
    paginationLabel: 'ترقيم الصفحات',
    prev: 'السابق',
    next: 'التالي',
    paginationSummary:
      'عرض {range} من {total} · صفحة {page} من {pages}',
    backToList: 'العودة إلى القائمة',
    loading: 'جاري التحميل…',
    loadingDetail: 'جاري تحميل تفاصيل الطالب...',
    notFoundMsg: 'الطالب غير موجود (المعرّف: {id})',
    backToStudentsList: '← العودة إلى قائمة الطلاب',
    detailNameMissing: 'لم يُذكر الاسم',
    detailCodeMissing: 'لم يُذكر الرمز',
    detailPhoneLabel: 'الهاتف',
    detailEmailLabel: 'البريد الإلكتروني',
    detailJoinDateLabel: 'تاريخ التسجيل',
    detailStatusLabel: 'الحالة',
    detailStatusUnknown: 'غير معروف',
    detailActiveEnrollmentsTitle: 'التسجيلات النشطة',
    detailNoActiveEnrollment: 'لا توجد تسجيلات نشطة',
    detailBadgeActive: 'نشط',
    detailScheduleLabel: 'المواعيد:',
    detailPeriodLabel: 'الفترة:',
    detailPeriodFrom: 'من',
    detailPeriodTo: 'إلى',
    detailTrainerLabel: 'المدرب:',
    detailRoomLabel: 'القاعة:',
    detailRoomUndefined: 'غير محددة',
    detailEnrollmentLabel: 'التسجيل:',
    notProvidedShort: 'غير مُذكر',
    formTitleEdit: 'تعديل الطالب',
    formTitleAdd: 'إضافة طالب',
    formSectionPersonal: 'المعلومات الشخصية',
    formFullName: 'الاسم الكامل *',
    formEmail: 'البريد الإلكتروني *',
    formPhone: 'الهاتف *',
    formPhonePlaceholder: '+213 XXX XXX XXX',
    formStatus: 'الحالة',
    formSectionAddress: 'العنوان',
    formStreet: 'الشارع / العنوان',
    formStreetPlaceholder: '١٢٣ شارع الجمهورية',
    formCity: 'المدينة',
    formCityPlaceholder: 'الجزائر',
    formPostalCode: 'الرمز البريدي',
    formPostalPlaceholder: '١٦٠٠٠',
    formState: 'الولاية',
    formCountry: 'البلد',
    formSectionTraining: 'التكوين الحالي',
    formBatchSelect: 'مجموعة الدورة',
    formBatchPlaceholder: 'اختر مجموعة',
    formBatchDetailsTitle: 'تفاصيل المجموعة:',
    formLblCourse: 'الدورة:',
    formLblTrainer: 'المدرب:',
    formLblSchedule: 'المواعيد:',
    formLblHours: 'الأوقات:',
    formLblPeriod: 'الفترة:',
    formLblPeriodSep: 'إلى',
    formLblSeats: 'المقاعد:',
    formLblSeatsRemain: '{n} متبقية',
    formLblRoom: 'القاعة:',
    formLblStatus: 'الحالة:',
    formJoinDate: 'تاريخ التسجيل',
    formBatchFullMark: 'مكتمل',
    formBatchPlacesAvail: '{n} مقعدًا',
    formStatusFull: 'مكتمل',
    formStatusAlmostFull: 'شبه مكتمل',
    formStatusFilling: 'يمتلئ',
    formStatusOpen: 'مفتوح',
    formPlacesParen: '{n} مقعدًا',
    formAlertBatchNotFound: '❌ خطأ: المجموعة غير موجودة',
    formAlertBatchFull:
      '❌ تعذّر تسجيل الطالب!\n\nمجموعة « {batch} » مكتملة.\n\n📊 السعة: {current}/{max} طالبًا\n\n💡 اختر مجموعة أخرى أو زِد السعة.',
    formAlertNoSpots:
      '❌ لا توجد أماكن متاحة!\n\nمجموعة « {batch} » لم يعد لديها مقاعد فارغة.\n\n📊 الأماكن المتبقية: {spots}',
    formAlertEnrollmentSuccess:
      '✅ تم التسجيل بنجاح!\n\n👤 الطالب: {name}\n📚 المجموعة: {batch}\n📊 السعة الجديدة: {current}/{max}\n🎯 الأماكن المتبقية: {remaining}',
    formAlertEnrollmentFailed: '❌ حدث خطأ أثناء التسجيل في المجموعة',
    deleteFailedShort: 'فشل الحذف',
    bulkDeletePartialError: 'تم حذف {success} من أصل {total} طالبًا فقط',
  },

  trainerForm: {
    backToList: 'العودة إلى القائمة',
    titleAdd: 'إضافة مدرب',
    titleEdit: 'تعديل المدرب',
    previewAlt: 'معاينة',
    photoSr: 'اختيار صورة',
    photoMaxError: 'لا يمكن أن يتجاوز حجم الصورة 5 ميغابايت',
    photoFormats: 'PNG أو JPG حتى 5 ميغابايت',
    nameLabel: 'الاسم الكامل*',
    codeLabel: 'رمز المدرب',
    phoneLabel: 'الهاتف*',
    emailLabel: 'البريد الإلكتروني',
    specialityLabel: 'التخصص',
    statusLabel: 'الحالة',
    joinDateLabel: 'تاريخ الانخراط',
    statusActive: 'نشط',
    statusInactive: 'غير نشط',
    statusLeave: 'في إجازة',
    cancel: 'إلغاء',
    submitAdd: 'إضافة',
    submitUpdate: 'تحديث',
    requiredName: 'الاسم مطلوب',
    requiredPhone: 'الهاتف مطلوب',
    invalidEmail: 'البريد غير صالح',
    saveError: 'حدث خطأ أثناء حفظ البيانات',
  },

  trainerDetail: {
    notFound: 'لم يُعثر على المدرب',
    backToList: 'العودة إلى القائمة',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    speciality: 'التخصص',
    joinDate: 'تاريخ الانخراط',
    notProvidedM: 'غير متوفر',
    notProvidedF: 'غير متوفرة',
    edit: 'تعديل',
  },

  commonActions: {
    viewDetails: 'عرض التفاصيل',
    edit: 'تعديل',
    delete: 'حذف',
    viewStudents: 'عرض الطلاب',
    editGroup: 'تعديل المجموعة',
    view: 'عرض',
    previewPdf: 'معاينة / PDF',
    exportPdf: 'تصدير PDF',
    print: 'طباعة',
    toggleStatusSr: 'انقر لتغيير الحالة',
    detailsSr: 'التفاصيل',
    refreshData: 'تحديث البيانات',
    prevYear: 'السنة السابقة (Shift+←)',
    nextYear: 'السنة التالية (Shift+→)',
    prevMonth: 'الشهر السابق (←)',
    nextMonth: 'الشهر التالي (→)',
    today: 'اليوم (Home)',
  },

  coursesPageTitle: 'الدورات',
  groupsPageTitle: 'المجموعات',
  studentsPageTitle: 'الطلاب',
  sessionsPageTitle: 'الجلسات',
  certificationsPageTitle: 'الشهادات',
  paymentsPageTitle: 'المدفوعات',
  classroomsPageTitle: 'القاعات',
  schedulePageTitle: 'الجدول الزمني',
  schedulePageLoadedEvents: '{n} حدث محمّل (تقريبًا لحظي)',
  benefitsPageTitle: 'المالية والإيرادات',
  reportsPageTitle: 'التقارير',
  evaluationsPageTitle: 'التقييمات',

  coursesPage: {
    title: 'الدورات',
    description: 'إدارة التكوينات والتسجيلات',
    newCourse: 'دورة جديدة',
    statsTotalTitle: 'إجمالي الدورات',
    statsTotalHint: 'في كتالوجك',
    statsOpenTitle: 'مفتوحة حاليًا',
    statsOpenHint: 'حالة «قيد الجري»',
    statsFilledTitle: 'الأماكن المحجوزة',
    statsFilledHint: 'تسجيلات مسجلة',
    tabAll: 'كل الدورات',
    tabActive: 'قيد الجري',
    tabPending: 'قادمة',
    tabCompleted: 'منتهية',
    statusLabel: 'الحالة',
    countAfterSearch: 'العدد بعد البحث',
    searchSrOnly: 'ابحث عن دورة',
    searchPlaceholder: 'الاسم، الرمز أو المدرب…',
    clearSearchAria: 'مسح البحث',
    filtersActive: 'عوامل التصفية النشطة',
    resetFilters: 'إعادة الضبط',
    selectedSingle: 'دورة واحدة محددة',
    selectedPlural: '{n} دورات محددة',
    deselectAll: 'إلغاء التحديد الكل',
    deleteBulk: 'حذف ({n})',
    confirmDeleteCourse: 'هل تريد حذف هذه الدورة بالتأكيد؟',
    deleteError: 'حدث خطأ أثناء الحذف',
    bulkDeleteError: 'حدث خطأ أثناء حذف الدورات',
    bulkDeleteAskOne: 'هل تريد حذف هذه الدورة بالتأكيد؟ لا يمكن التراجع.',
    bulkDeleteAskMany: 'هل تريد حذف {n} دورات بالتأكيد؟ لا يمكن التراجع.',
    bulkDeleteCancel: 'إلغاء',
    bulkDeleteConfirm: 'حذف',
    emptyTitle: 'لا توجد دورات للعرض',
    emptyBody:
      'جرّب بحثًا آخر، أو غيّر تبويب الحالة، أو أنشئ دورة جديدة.',
    clearFiltersBtn: 'مسح التصفية والبحث',
    listHeading: 'قائمة الدورات',
    resultsSingular: 'نتيجة',
    resultsPlural: 'نتائج',
    rangeOn: 'النطاق',
    onTotal: 'من',
    perPage: 'لكل صفحة',
    srSelection: 'تحديد',
    selectAllPageAria: 'تحديد الكل في هذه الصفحة',
    colCourse: 'الدورة',
    colCode: 'الرمز',
    colTrainerCol: 'المدرب',
    colStatusCol: 'الحالة',
    colStudentsCol: 'الطلاب',
    colStartCol: 'البداية',
    colActions: 'إجراءات',
    paginationAria: 'ترقيم الصفحات',
    prevPage: 'السابق',
    nextPage: 'التالي',
    paginationSummary:
      'عرض {range} من {total} · صفحة {page} من {pages}',
    capacitySuffix: '{n} طلاب',
    batchTotalStudents: 'المجموع : {n} طالب{s}',
    batchPluralS: '',
    batchPluralEmpty: 'ين',
    noStudentYet: 'لا يوجد طلاب مسجلون بعد',
    noStudentEnrolledTitle: 'لا يوجد طلاب مسجلون',
    noStudentEnrolledBody: 'لم يتم تسجيل طلاب في هذه المجموعة بعد.',
    batchFormTitleEdit: 'تعديل المجموعة',
    batchFormTitleNew: 'إنشاء مجموعة جديدة',
    batchSubmitEdit: 'تعديل المجموعة',
    batchSubmitCreate: 'إنشاء المجموعة',
    trainerConflictAlert:
      'تعارض في جدولة هذا المدرّب. اختر وقًا آخر أو مدرّبًا آخر.',
    batchSaveError: 'خطأ أثناء حفظ المجموعة',
    confirmDeleteBatch: 'هل تريد حذف هذه المجموعة بالتأكيد؟',
    courseFormSubmitUpdate: 'تحديث',
    courseFormAddTitle: 'إضافة دورة',
    courseFormEditTitle: 'تعديل الدورة',
    courseFormSubmitAdd: 'إضافة',
    bulkModalTitle: 'تأكيد الحذف',
    addCourseShortcut: 'إضافة دورة',
    selectCourseRowAria: 'تحديد {name}',
    colPeriod: 'الفترة',
    colEnrollments: 'التسجيلات',
    trainerNotAssigned: 'غير معيّن',
    trainerSpecialityMissing: 'غير محدد',
    endsOnPrefix: 'إلى',
    detailBackToList: 'العودة إلى القائمة',
    statusLblActiveRow: 'قيد الجري',
    statusLblPendingRow: 'قادمة',
    statusLblCompletedRow: 'منتهية',

    weekdays: {
      Monday: 'الإثنين',
      Tuesday: 'الثلاثاء',
      Wednesday: 'الأربعاء',
      Thursday: 'الخميس',
      Friday: 'الجمعة',
      Saturday: 'السبت',
      Sunday: 'الأحد',
    },

    batchLblGroupName: 'اسم المجموعة',
    batchPlaceholderGroupSuffix: '{name} — مجموعة أ',
    batchLblDays: 'أيام الأسبوع',
    batchLblStartTime: 'وقت البداية',
    batchLblEndTime: 'وقت النهاية',
    batchLblStartDateShort: 'تاريخ البداية',
    batchLblEndDateShort: 'تاريخ النهاية',
    optionalSuffix: 'اختياري',
    periodNotSet: 'الفترة غير محددة',
    batchLblTrainerShort: 'المدرّب',
    batchSelectTrainer: 'اختر مدرّبًا',
    trainerFallbackNamed: 'مدرّب {id}',
    batchLblMaxCapacity: 'السعة القصوى',
    batchLblRoomOptional: 'القاعة (اختياري)',
    batchRoomPlaceholder: 'قاعة أ1',
    conflictDetectedTitle: '⚠️ تم رصد تعارض في الجدولة!',
    conflictDetectedSub:
      'للمُدرَّب المختار حصص بنفس المواعيد.',
    conflictingCoursesHdr: '📅 الدورات المتعارضة:',
    conflictRoomLbl: '🏫 القاعة:',
    suggestTitle: '💡 مقترحات:',
    suggestLine1: '• اختر مدرّبًا آخر متفرغًا',
    suggestLine2: '• عدِّل أيام الأسبوع',
    suggestLine3: '• غيّر أوقات البداية/النهاية',
    suggestLine4: '• أنشئ هذه المجموعة في فترة أخرى',

    unknownTrainer: 'غير معروف',
    batchesTabHeading: 'المجموعات',

    batchEmptyTitle: 'لم يُنشَأ أي مجموعة',
    batchEmptySubtitle: 'أنشئ مجموعات بمواعيد محددة لهذه الدورة',
    batchCreateFirst: 'إنشاء أول مجموعة',
    lblTrainerColon: 'المدرّب:',
    lblRoomColon: 'القاعة:',
    lblStartColon: 'البداية:',
    lblEndColon: 'النهاية:',
    roomUndefined: 'غير محددة',
    studentsModalClose: 'إغلاق',
    enrollmentProgress: '{current}/{capacity}',

    courseFormLblTitle: 'عنوان الدورة',
    courseFormLblStartDate: 'تاريخ البداية',
    courseFormLblEndDate: 'تاريخ النهاية',
    courseFormLblDurationHrs: 'المدة (بالساعات)',
    courseFormLblPriceDa: 'السعر (دج)',
    courseFormLblCapacity: 'السعة',
    courseFormLblTrainer: 'المدرّب',
    courseFormLblStatusShort: 'الحالة',
    courseFormOptPending: 'قادمة',
    courseFormOptActive: 'قيد الجري',
    courseFormOptCompleted: 'منتهية',
    courseFormLblDescription: 'الوصف',

    loadingCourse: 'جاري التحميل…',
    courseNotFound: 'الدورة غير موجودة (المعرّف: {id})',
    backCoursesListShort: '← العودة إلى قائمة الدورات',
    loadingCourseDetails: 'جاري تحميل تفاصيل الدورة…',

    /** مجموعات نموذج الدورة والقاعة */
    batchLblCourseShort: 'الدورة',
    batchSelectCourse: 'اختر دورةً',
    batchSelectRoom: 'اختر قاعةً',
    batchGroupNamePlaceholder: 'مثال: مجموعة أ، صباحًا، مساءً…',
    batchLblTrainerForm: 'المدرّب',
    batchRoomOccupiedSuffix: '- مشغولة',
    roomPickMetaLine:
      '{name} ({code}) · السعة: {capacity} {occupied}',
    roomDetailsCapacityFloor: 'السعة: {cap} • الطابق: {floor}',
    floorNA: 'غير متاح',
    equipmentPcShort: '💻 حاسوب',
    tabDetailsCourse: 'التفاصيل',
    sectionDescription: 'الوصف',
    sectionTrainer: 'المدرّب',
    sectionEnrolledStudents: 'الطلاب المسجلون',
    lblPeriodShort: 'الفترة',
    lblDurationShort: 'المدة',
    lblCapacityShort: 'السعة',
    lblPriceShort: 'السعر',
    newBatchBtn: 'مجموعة جديدة',
    courseTitleFallbackShort: 'الدورة',
    cancelBtnShort: 'إلغاء',
  },

  groupsPage: {
    courseFallbackName: 'الدورة',
    batchSaveSuccessUpdated: '✅ تم تعديل المجموعة بنجاح!',
    batchSaveSuccessCreated: '✅ تم إنشاء مجموعة جديدة!',
    batchSaveError: 'خطأ أثناء حفظ المجموعة',
    daysNotDefined: 'غير محددة',
    nameNotDefined: 'اسم غير محدد',
    courseNotDefinedShort: 'دورة غير محددة',
    trainerNotAssigned: 'غير معين',
    courseNotFoundShort: 'الدورة غير موجودة',
    statCumulativeCapacityTitle: 'إجمالي الأماكن',
    statCumulativeCapacityHint: 'الحد الأقصى لسعة المجموعات',
    newGroup: 'مجموعة جديدة',
    backToList: 'العودة إلى القائمة',
    loadingList: 'جاري تحميل المجموعات…',

    statsTotalGroupsTitle: 'المجموعات',

    emptyTitleNoMatch: 'لم يُعثر على مجموعات',
    emptyBodyFiltered: 'لا مجموعة لهذه الدورة',
    emptyBodyCreateFirst: 'أنشئ مجموعة الدورة الأولى',
    createFirstGroup: 'إنشاء أول مجموعة',
    viewStudentsSr: 'عرض الطلاب',
    enrollmentShort: 'التسجيلات',
    noStudentsInBatchTitle: 'لا يوجد طلاب مسجلون',
    noStudentsInBatchBody: 'لم يُسجل طلاب في هذه المجموعة بعد.',
    studentsModalClose: 'إغلاق',

    filterCourseChipLbl: 'الدورة',
    filterListHintLbl: 'تصفية القائمة',
    statsAllFormationsHint: 'كل التكوينات',
    statsCoursesWithGroupsTitle: 'دورات مغطاة',
    statsCoursesWithGroupsHint: 'فيها مجموعة واحدة على الأقل',
    unknownCourseTitle: 'دورة غير معروفة',
    groupsPerCourseSuffix: '{n} مجموعة(ات)',
    modalStudentsForBatchTitle: 'الطلاب المسجّلون — {name}',
    modalTotalStudentCount: 'المجموع: {n} طالب(ين)',
    modalCapacityLabelShort: 'السعة',
    enrolledOnPrefix: 'مسجّل في:',
    confirmDeleteGroup: 'هل تريد حذف هذه المجموعة بالتأكيد؟',
    deleteGroupError: 'خطأ أثناء حذف المجموعة.',
  },

  certificationsDetail: {
    title: 'تفاصيل الشهادة',
    notFoundTitle: 'الشهادة غير موجودة',
    notFoundBody: 'تعذر تحميل تفاصيل هذه الشهادة.',
    printBtn: 'طباعة',
    brandLine: 'FORMA PRO EXCELLENCE',
    awardedTo: 'منحت لـ:',
    instructorLbl: 'المدرّب:',
    issueDateLbl: 'تاريخ الإصدار',
    expiryDateLbl: 'تاريخ الانتهاء',
    remarksLbl: 'ملاحظات',
    certificateBodyLegal:
      'تشهد هذه الوثيقة بأن المتعلّم أكمل برنامج التكوين بنجاح.',
    statusColon: 'الحالة:',
    typeColon: 'النوع:',
    editBtn: 'تعديل',
    subheadingPortfolio: 'نظرة موجزة على المحفظة',
    emptyListTitle: 'لا توجد شهادات',
    emptyListCta: 'إنشاء شهادة',
    listCardTitle: 'قائمة الشهادات',
    newFormStub: 'استمارة الإنشاء',
    editPageTitle: 'تعديل الشهادة',
    typeDiploma: 'دبلوم',
    typeCertificationShort: 'شهادة مهنية',
    typeAttestation: 'شهادة حضور',
    statusIssuedUpper: 'أُصدِرت',
    statusPendingUpper: 'قيد الانتظار',
    diplomaUpper: 'دبلوم',
    certificationUpper: 'شهادة',
    attestationUpper: 'إقرار',
    statusIssued: 'مُصدَرة',
    statusPendingLabel: 'قيد الانتظار',
    filterAllTypes: 'كل الأنواع',
    toastViewStarted: 'جاري عرض الشهادة {id}',
    toastDownloadStarted: 'بدأ تنزيل الشهادة',
    toastDownloadError: 'خطأ: {error}',
    dateShortLbl: 'التاريخ:',
    idShortLbl: 'المعرّف:',
    sectionByTypeTitle: 'التوزيع حسب النوع',
    pctOfTotalCerts: '{pct}% من الشهادات',
    searchCertSr: 'بحث عن شهادة',
    searchCertPlaceholder: 'طالب، عنوان أو مدرّب…',
    emptyFilteredBody: 'لا نتيجة مطابقة لمعايير البحث.',
    tableColId: 'المعرّف',
    tableColStudent: 'طالب',
    tableColTitle: 'العنوان',
    tableColDate: 'التاريخ',
    tableColType: 'النوع',
    tableColStatus: 'الحالة',
    tableColActions: 'إجراءات',
    pageSliceShow: 'عرض {from}–{to} من {total}',
    toastEditMode: 'تعديل الشهادة {id}',
    filterTypeChip: 'النوع: {label}',
  },

  certificationsComponents: {
    formTitleNew: 'شهادة جديدة',
    formTitleEdit: 'تعديل الشهادة',
    studentNameLbl: 'اسم الطالب',
    selectStudent: 'اختر طالبًا',
    certificateTypeLbl: 'نوع الشهادة',
    certificateTitleLbl: 'العنوان',
    issueDateFieldLbl: 'تاريخ الإصدار',
    expirationFieldLbl: 'تاريخ الانتهاء',
    noExpiryCheckbox: 'صالحة مدى الحياة (بدون انتهاء)',
    noExpiryBadge: '✓ ستكون هذه الشهادة صالحة مدى الحياة',
    scoreFieldLbl: 'النتيجة (من 100)',
    detailScoreLbl: 'النتيجة',
    instructorNameLbl: 'اسم المدرّب',
    selectTrainer: 'اختر مدرّبًا',
    cancelBtn: 'إلغاء',
    submitAdd: 'إضافة',
    submitUpdate: 'تحديث',

    modalPreviewDeliveredPrefix: 'أُصدرت في:',
    modalPreviewTrainerPrefix: 'المدرّب:',
    modalPreviewExpirePrefix: 'تنتهي في:',
    modalPreviewValidForeverShort: '∞ صالحة مدى الحياة',
    modalPreviewScorePrefix: 'النتيجة :',

    modalTemplateAlt: 'القالب',

    svgPdfLoadedFallback: 'تم تحميل قالب PDF',
    svgPdfSubFallback: '(معاينة مبسّطة — سيستخدم الملف النهائي قالبك)',

    modalTemplateLoading: 'جاري تحميل القالب…',
    modalTemplateRequired: 'القالب مطلوب',
    modalTemplateRequiredBody:
      'لم يُضبط قالب شهادة. يرجى رفع قالب من الإعدادات.',
    modalGoSettings: 'الذهاب إلى الإعدادات',
    modalPreviewWithTemplate:
      '✨ معاينة بالقالب المخصص: {name}. سيستخدم تصدير PDF نفس المواضع.',
    modalPreviewNoTemplate:
      'لا يوجد قالب مخصص. أضف واحدًا من الإعدادات ← الشهادات.',

    modalDownloadPdf: 'تنزيل PDF',
    modalPreparing: 'جاري تجهيز الشهادة…',
    modalDownloadOkTitle: 'اكتمل التنزيل!',
    modalDownloadOkBody: 'تم تنزيل الشهادة بنجاح.',
    modalPrintNow: 'طباعة الآن',
    modalErrorRetry: 'حدث خطأ. يُرجى المحاولة مرة أخرى.',
    modalRetryBtn: 'إعادة المحاولة',
    modalMetaSectionTitle: 'تفاصيل الشهادة',
    modalCertIdMeta: 'معرّف الشهادة',
    modalStudentIdMeta: 'معرّف الطالب',
    modalPrintErrorAlert:
      'خطأ أثناء الطباعة. يُرجى المحاولة مرة أخرى.',

    listEmptyTitle: 'لا توجد شهادة',
    listEmptyBody: 'لا شهادة تطابق معايير البحث.',

    dateNotDefined: 'غير محددة',
    printExpiresLine: 'تنتهي في:',

    detailDeliveredPrefixIssued: 'أُصدِرت في',
    detailDeliveredPrefixPending: 'مقرّرة في',
    detailDatePending: 'تاريخ لم يحدد بعد',
    detailStudentLbl: 'طالب',
    detailTrainerLbl: 'مدرّب',
    detailExpirySectionLbl: 'تاريخ الانتهاء',
    detailNoExpirySub: '(بدون انتهاء)',
    detailExpired: 'منتهية',
    detailClose: 'إغلاق',
    detailDownloading: 'جاري التنزيل…',
    detailDownloadBtn: 'تنزيل',
    detailPdfFailAlert: 'خطأ أثناء إنشاء PDF. يُرجى المحاولة.',
    detailGenericFailAlert: 'حدث خطأ. يُرجى المحاولة.',

    downloadAlertOk: 'تم تنزيل الشهادة بنجاح',

    printDocTitleBase: 'شهادة',

    printOverlayIssued: 'أُصدرت في:',
    printOverlayTrainer: 'المدرّب:',
    printOverlayExpires: 'تنتهي في:',
    printOverlayInfinity: '∞ صالحة مدى الحياة',
    printOverlayScore: 'النتيجة:',
    printOverlayFooterLine: 'المعرّف: {id} · FORMAPRO',

    printDefaultIntro: 'تشهد هذه الوثيقة بأن',
    printDefaultSuccessLine: 'أتمّ بنجاح',
    printDefaultIssuedLbl: 'تاريخ الإصدار:',
    printDefaultTrainerLbl: 'المدرّب:',
    printDefaultExpiryLbl: 'تاريخ الانتهاء:',
    printDefaultScoreLbl: 'النتيجة:',
    printDefaultValidityForever: '∞ صالحة مدى الحياة',
    printDefaultSigTrainer: 'توقيع المدرّب',
    printDefaultSigDir: 'الإدارة',
    printDefaultSealValidated: 'مُعتمدة',
    printDefaultFooterMeta: 'المعرّف: {id} · FORMAPRO',
    printDefaultHdrSuffix: ' — FORMAPRO',
  },

  schedulePageUi: {
    edit: 'تعديل',
    delete: 'حذف',
    schedulesLbl: 'المواعيد',
    trainerLbl: 'المدرّب',
    classroomLbl: 'القاعة',
    courseLbl: 'الدورة',
    loadingTitle: '🔄 جاري تحميل الجدول الزمني…',
    loadingSub:
      'مزامنة الجلسات والدورات والمجموعات والقاعات والمدربين',
    newCourseShortcut: 'دورة جديدة',
    repartitionDayTitle: 'التوزيع حسب اليوم',
    weeklyLoadSubtitle: 'الحمل الأسبوعي',
    filterAllCourses: 'كل الدورات',
    filterConfirmed: 'مؤكّدة',
    filterPendingSessions: 'قيد الانتظار',
    dayViewTitle: 'عرض اليوم',
    dailySummaryTitle: 'ملخص اليوم',
    totalCoursesLbl: 'إجمالي الدورات',
    courseUnspecified: 'لم تُحدد الدورة',
    trainerUnspecified: 'لم يُحدد المدرّب',
    classroomUnspecified: 'لم تُحدد القاعة',
    statEventsScheduled: 'أحداث مجدولة',
    statSlotsWeek: 'لفترات هذا الأسبوع',
    statTrainersReferential: 'دليل المدربين',
    sessionDeletedToast: 'تم حذف الجلسة بنجاح',
    confirmDeleteSession: 'هل تريد حذف جلسة التكوين هذه بالتأكيد؟',
    deleteDeniedBatch: 'احذف هذه المجموعة من صفحة الدورات أو المجموعات',
    deleteErrorToast: 'حدث خطأ أثناء الحذف',
    statRoomsAvailableHint: 'الفضاءات المتاحة',
    kpiTotalCoursesTitle: 'إجمالي الدورات',
    kpiThisWeekTitle: 'هذا الأسبوع',
    kpiFormateursTitle: 'المدرّبون',
    kpiRoomsTitleShort: 'القاعات',
    tabWeekView: 'عرض أسبوعي',
    tabDayView: 'عرض يومي',
    tabByTrainer: 'حسب المدرّب',
    tabByCourse: 'حسب الدورة',
    tabByRoom: 'حسب القاعة',
    pctOfCoursesLine: '{pct}% من الدورات',
    searchCoursesSr: 'بحث عن دورة',
    searchPlaceholderSchedule: 'عنوان، مدرّب، قاعة…',
    clearSearchShort: 'مسح',
    monthCoursesSummary: '{n} دورة هذا الشهر',
    calendarMoreOther: '+ {n} آخر',
    calendarMoreOthers: '+ {n} أخرى',
    eventHoverTimeRange: '{title} · {start} إلى {end}',
    eventDetailTitle: 'تفاصيل الدورة',
    linkTrainersPage: 'صفحة المدرّبين',
    linkRoomsPage: 'صفحة القاعات',
    linkCoursesPage: 'صفحة الدورات',
    capacityLine: 'السعة : {n} مقعدًا',
    codeLblShort: 'الرمز :',
    coursesByTrainerTitle: 'الجدول حسب المدرّب',
    coursesByCourseTitle: 'الجدول حسب الدورة',
    coursesByRoomTitle: 'الجدول حسب القاعة',
    coursesThisWeekLine: '{n} دورة هذا الأسبوع',
    sessionsThisWeekLine: '{n} جلسة هذا الأسبوع',
    trainerFallbackName: 'مدرّب',
    statusActiveLbl: 'نشط',
    statusInactiveLbl: 'غير نشط',
    noCoursesAssignedWeek: 'لا دورات مسندة هذا الأسبوع',
    noSessionsPlannedWeek: 'لا جلسات مجدولة هذا الأسبوع',
    roomSessionsMeta: 'السعة : {cap} • {n} جلسات',
    occupancyPct: 'نسبة الإشغال {pct}٪',
    roomFreeThisWeek: 'القاعة متاحة هذا الأسبوع',
    fallbackDay: 'يوم',
    durationHoursShort: '{n} س',
    durationUnknown: '—',
    groupLabelShort: 'مجموعة {name}',
    stubAddCourse: 'إضافة دورة جديدة',
    stubEditCourse: 'تعديل الدورة',
    modalAddCourseTitle: 'إضافة دورة',
    modalSelectCourse: 'اختر دورة',
    modalSelectTrainer: 'اختر مدرّبًا',
    modalSelectRoom: 'اختر قاعة',
    batchStartLbl: 'ساعة البداية',
    batchEndLbl: 'ساعة النهاية',
    closeModalBtn: 'إغلاق',
    cancelModalBtn: 'إلغاء',
    addModalSubmit: 'إضافة',
    summaryTrainersLbl: 'مدرّبون',
    summaryRoomsUsedLbl: 'قاعات مستخدمة',
    summaryHoursTotalLbl: 'مجموع الساعات',
    sessionDefaultTitle: 'تكوين',
    todayLabel: 'اليوم',
  },

  paymentsPageUi: {
    methodCash: 'نقدًا',
    methodCard: 'بطاقة',
    transfer: 'تحويل',
    methodCheck: 'شيك',
    unspecified: 'غير محدد',
    undef: 'غير معرف',
    noCourseChosen: 'لم يُحدد دورة',
    paidLbl: 'مدفوع',
    partialLbl: 'مدفوع جزئيًا',
    toastSelectStudent: 'يرجى اختيار طالب',
    toastSelectEnrollment: 'يرجى اختيار تسجيل (مجموعة)',
    amountPaidGtTotal: 'المبلغ المدفوع لا يمكن أن يتجاوز الإجمالي',
    amountPaidMustBeGt0: 'يجب أن يكون المبلغ المدفوع أكبر من صفر',
    saveErrorToast: 'حدث خطأ أثناء حفظ البيانات',
    helperNoStudentOrCourse:
      'لا طالبًا ولا دورة. أضفهم من صفحاتهم.',
    helperNoStudent: 'لا طلاب. أضف طلابًا من صفحة الطلاب.',
    helperNoCourses: 'لا دورات. أضف دورات من صفحة الدورات.',
    selectStudentPlaceholder: 'اختر طالبًا',
    noStudentsAvail: 'لا يوجد طلاب متاحون',
    courseAssignedShort: 'دورة محددة',
    pickStudentFirstHint: 'اختر طالبًا أولاً',
    selectBatchPlaceholder: 'اختر مجموعة',
    badgePaidSuffix: '✅ مدفوع',
    badgePartialSuffix: '🟡 جزئي',
    badgePendingSuffix: '⏳ قيد الانتظار',
    placeholderAmountPaid: 'أدخل المبلغ المدفوع',
    placeholderCoursePrice: 'اختر دورة لعرض السعر',
    placeholderNotesPayment: 'ملاحظات إضافية عن الدفع…',
    btnUpdate: 'تحديث',
    btnSave: 'حفظ',
    statTotalPaymentsTitle: 'إجمالي المدفوعات',
    statTotalPaymentsHint: 'سجلات',
    statAmountPaidTitle: 'المبلغ المحصّل',
    statAmountPaidHint: 'التحصيلات التراكمية',
    statFullyPaidTitle: 'مسدَّدة بالكامل',
    statFullyPaidHint: 'فواتير مغلقة',
    statOutstandingTitle: 'الباقي للتحصيل',
    emptyPaymentsHint: 'لا مدفوعات للعرض',
    phoneFallback: 'الهاتف غير مسجل',
    pdfExportOk: 'تم تصدير PDF بنجاح',
    searchPlaceholderPayments: 'مرجع، طالب، دورة…',
    tabPaidOnly: 'المدفوعة فقط',
    tabPartialOnly: 'الجزئية فقط',
    paymentDetailMissing: 'تفاصيل الدفع غير متوفرة.',
    invoicePrefix: 'فاتورة #',
    issuedOnLbl: 'صُدرت في',
    clientLbl: 'العميل',
    courseSectionLbl: 'الدورة',
    paymentDetailsLbl: 'تفاصيل الدفع',
    courseTotalLbl: 'المبلغ الإجمالي للدورة',
    paidAmountLbl: 'المبلغ المدفوع',
    remainingLbl: 'المتبقي',
    closeBtn: 'إغلاق',
    studentFallbackName: 'طالب',
    methodCardBank: 'بطاقة بنكية',
    methodTransferBank: 'تحويل بنكي',
    backToPayments: 'العودة إلى المدفوعات',
    newPaymentBtn: 'دفع جديد',
    searchPaymentsSr: 'بحث عن دفعة',
    clearSearchAria: 'مسح البحث',
    tabAll: 'الكل',
    tabPaidShort: 'مدفوعة',
    tabPartialShort: 'جزئية',
    tabOverdueShort: 'متأخر',
    tabOverdueOnly: 'المتأخر فقط',
    lblDueDateField: 'تاريخ الاستحقاق',
    dueDateLbl: 'استحقاق الرصيد',
    dueDateHint: 'يُملأ تلقائياً حسب شروط الدفع ({days} يوم) — الإعدادات → الفوترة',
    overdueBadge: 'متأخر',
    toastDueDateRequired: 'يرجى تحديد تاريخ استحقاق للمبلغ المتبقي',
    colDueDateTbl: 'الاستحقاق',
    activeFiltersLbl: 'مرشحات نشطة',
    resetFiltersBtn: 'إعادة التعيين',
    bulkSelectedPayments: '{n} دفعة محدَّدة',
    deselectAllBtn: 'إلغاء تحديد الكل',
    deleteBulkBtn: 'حذف ({n})',
    paymentListHeading: 'قائمة المدفوعات',
    pageSliceShown: 'عرض {start}–{end} من {total}',
    colReferenceShort: 'المرجع',
    colStudentShort: 'الطالب',
    colCourseTbl: 'الدورة',
    colDateTbl: 'التاريخ',
    colAmountTbl: 'المبلغ',
    colStatusTbl: 'الحالة',
    colActionsTbl: 'إجراءات',
    statOutstandingOpenHint: 'مبالغ مفتوحة',
    installmentsHeading: 'جدول الأقساط',
    installmentNth: 'قسط {n}',
    installmentDatePrefix: 'التاريخ:',
    paymentMethodLbl: 'طريقة الدفع',
    lblStatusPayment: 'الحالة',
    formTitleNewPayment: 'دفع جديد',
    formTitleEditPayment: 'تعديل الدفع',
    lblStudentField: 'الطالب',
    lblEnrollmentField: 'التسجيل (مجموعة)',
    lblTotalAmountField: 'المبلغ الإجمالي (دج)',
    lblDateField: 'التاريخ',
    lblPaymentKind: 'نوع الدفع',
    paymentKindFull: 'دفع كامل',
    paymentKindPartial: 'دفع جزئي',
    lblPaidTodayField: 'المبلغ المدفوع اليوم (دج)',
    lblRemarksField: 'ملاحظات',
    placeholderNotesSupplement: 'معلومات إضافية عن هذا الدفع…',
    labelMontantTotalShort: 'الإجمالي:',
    labelMontantPayeShort: 'المدفوع:',
    labelMontantRestantShort: 'المتبقي:',
    selectStudentFirstBanner:
      'اختر الطالب أولًا لعرض تسجيلاته.',
    enrollmentCountBanner: '{n} تسجيل(ات) نشطة',
    studentCountAvail: '{n} طالب(طلاب) متاحون',
    cancelLink: 'إلغاء',
    toastTotalAmountRequired: 'المبلغ الإجمالي مطلوب',
    toastStudentEnrollFound: 'تم العثور على {n} تسجيل(ات) لـ {name}',
    toastNoActiveEnrollmentStudent: 'لا تسجيل نشط لـ {name}',
    toastBatchSelectedPrice:
      'المجموعة « {batch} » — السعر : {price} دج',
    studentMissingPlaceholder: 'طالب غير موجود',
    courseNotFoundTitle: 'لم يُعثر على الدورة',
    confirmDeleteOnePayment: 'حذف هذه الدفعة بالتأكيد؟',
    toastPaymentDeletedOk: 'تم حذف الدفعة بنجاح',
    toastPaymentDeleteFail: 'حدث خطأ أثناء الحذف',
    toastBulkPaymentsDeletedOk: 'تم حذف {n} دفعة(دفعات) بنجاح',
    toastBulkPaymentsDeleteFail: 'خطأ أثناء حذف الدفعات',
    bulkDeleteTitlePayments: 'تأكيد الحذف',
    bulkDeleteAskPayments:
      'حذف {n} دفعة(دفعات) بالتأكيد؟ لا يمكن التراجع عن هذا الإجراء.',
    cancelBtnPayments: 'إلغاء',
    deleteBtnPayments: 'حذف',
    titleViewPayment: 'عرض',
    titleEditPayment: 'تعديل',
    titleExportPdf: 'تصدير PDF',
    titlePrintReceipt: 'طباعة',
    titleDeletePayment: 'حذف',
    toastWaitSettingsLoad: 'جاري التحميل، يرجى الانتظار…',
    toastMemberInfoMissingPayment:
      'تعذَّر العثور على معلومات العضو لهذه الدفعة',
    toastPdfExportError: 'خطأ أثناء تصدير PDF',
    toastPrintIframeError: 'خطأ أثناء تحميل نافذة الطباعة',
    toastPrintError: 'خطأ أثناء الطباعة',
    orgFallbackAddress: 'مؤسسة تكوين',
    pdfReceiptTitle: 'وصل',
    pdfLblNum: 'رقم :',
    pdfLblDate: 'التاريخ :',
    pdfLblReceivedFrom: 'استلمنا من :',
    pdfLblFor: 'من أجل :',
    pdfLblMethod: 'طريقة :',
    pdfLblReference: 'المرجع :',
    pdfLblAmount: 'المبلغ :',
    pdfLblAmountWords: 'بالأحرف :',
    pdfDinarsTail: '{words} دينارًا',
    pdfDescFormation: 'دفع التكوين',
    pdfNumericAmountFallback: '{amount}',
    printCloseBtn: '✕ إغلاق',
    paginationAriaLabel: 'التنقل بين الصفحات',
    paginationPrev: 'السابق',
    paginationNext: 'التالي',
  },

  sessionsPageTabs: {
    attendance: 'الحضور',
    completed: 'منتهية',
    cancelled: 'ملغاة',
  },

  sessionsPageUi: {
    backToList: 'العودة إلى القائمة',
    newSessionBtn: 'جلسة جديدة',
    courseFallbackShort: 'دورة',
    trainerFallbackShort: 'مكون',
    roomTbdShort: 'قاعة — لاحقًا',
    statSessionsTodayTitle: 'جلسات اليوم',
    statSessionsTodayHint: 'تسجيلات الدخول اليوم',
    statActiveSessionsTitle: 'جلسات نشطة',
    statActiveSessionsHint: 'أعضاء في القاعة حاليًا (دون مغادرة)',
    statAvgDurationTitle: 'متوسط المدة',
    statAvgDurationHintAvg: 'متوسط على الجلسات المكتملة',
    statAvgDurationHintNone: 'لا توجد مدة مسجّلة',
    minSuffix: '{n} دقيقة',
    dashEm: '—',
    tabAllSessions: 'كل الجلسات',
    tabScheduleBtn: 'التخطيط',
    tabActiveSessions: 'جلسات نشطة',
    tabCheckIn: 'التسجيل',
    tabTrainingFormation: 'تكوين',
    tabStats: 'إحصائيات',
    distByStatusHeading: 'التقسيم حسب الحالة',
    distByStatusSub: 'نظرة عامة على جلساتك المسجّلة',
    distNameCompleted: 'منتهية',
    distNameActive: 'نشطة',
    distNameCancelled: 'ملغاة',
    distPctSessions: '{pct}% من الجلسات',
    searchSrOnly: 'بحث عن جلسة',
    searchPlaceholderMemberId: 'عضو أو معرف جلسة…',
    clearSearchAriaSessions: 'مسح البحث',
    filtAllStatuses: 'كل الحالات',
    filtStatusActivePlural: 'نشطة',
    filtChipStatus: 'الحالة: {status}',
    filtersActiveLbl: 'مرشحات نشطة',
    resetFiltersSessions: 'إعادة التعيين',
    trainingSessionsHeading: 'جلسات التكوين',
    newTrainingBtn: 'تكوين جديد',
    emptyTrainingTitle: 'لا جلسات تكوين',
    emptyTrainingBody:
      'لم تُنشأ بعد جلسات تكوين. ابدأ بإضافة واحدة.',
    scheduleCoursesHeading: 'تخطيط الدورات',
    weeklyViewLbl: 'عرض أسبوعي',
    scheduleConflictsTitle: '⚠️ تعارض في الأوقات',
    scheduleConflictsSub:
      '{nGroups} مجموعة بتعارض • {nTrainers} مكون(s) متأثر',
    actionRequiredLbl: 'إجراء مطلوب',
    resolveConflictsCourses: 'حل التعارضات من صفحة الدورات',
    noCoursesScheduledTitle: 'لا دورات مجدولة',
    noCoursesScheduledBody:
      'أنشئ مجموعات من قسم الدورات لعرض التخطيط',
    dayCellNoCourse: 'لا دورة',
    conflictTrainerBadge: '⚠️ تعارض مكون',
    slotFullLbl: 'ممتلئة',
    slotOpenLbl: 'مفتوحة',
    conflictsDetectedLine: 'تعارضات:',
    andMoreOthers: '… و {n} آخرين',
    todaysClassesHeading: 'صفوف اليوم',
    noCoursesToday: 'لا دروس اليوم',
    attendanceHeading: 'تتبع الحضور',
    dailyMgmtLbl: 'إدارة يومية',
    selectBatchLbl: 'اختر مجموعة',
    pickBatchPlaceholder: 'اختر مجموعة',
    batchOptionCourseStudents: '{course} — {batch} ({n} طالبًا)',
    sessionDateLbl: 'تاريخ الجلسة',
    selectedSessionLine: 'الجلسة المحددة : {date}',
    toggleHideStatsLbl: 'إخفاء الإحصائيات',
    toggleShowStatsLbl: 'عرض الإحصائيات',
    emptyBatchStudentsTitle: 'لا طلاب مسجَّلون',
    emptyBatchStudentsBody: 'لا يوجد طلاب مسجَّلون في هذه المجموعة بعد.',
    rosterHeading: 'قائمة الحضور — {batch}',
    markAllPresent: 'الكل حاضر',
    markAllAbsent: 'الكل غائب',
    presentLbl: 'حاضر',
    absentLbl: 'غائب',
    notesOptionalPh: 'ملاحظات (اختياري)',
    saveAttendanceBtn: 'حفظ الحضور',
    attendanceSavedToast:
      '✅ تم حفظ الحضور!\n✅ حاضرون: {present}\n❌ غائبون: {absent}',
    attendanceSaveError: '❌ خطأ أثناء حفظ الحضور',
    statsAttendanceHeading: 'إحصائيات الحضور',
    noAttendanceYetGroup: 'لا سجلات حضور لهذه المجموعة',
    statsSessionsRecordedLbl: 'جلسات مسجّلة',
    statsAvgAttendanceRateLbl: 'متوسط معدل الحضور',
    statsStudentsTrackedLbl: 'طلاب متابعون',
    rateByStudentHeading: 'الحضور لكل طالب',
    scheduleConflictChip: '⚠️ تعارض',
    conflictTrainerOtherCourses:
      'تعارض مع {n} دورة أخرى لنفس المكون',
    studentsCountShort: '{n} طالبًا',
    spotsLeftSuffix: '{n} مقعدًا',
    emptySessionListTitle: 'لا توجد جلسات',
    emptySessionListBody: 'لا نتيجة مطابقة لمعايير البحث.',
    createSessionBtn: 'إنشاء جلسة',
    bulkSelectedSessions: '{n} جلسة محدَّدة',
    deselectAllSessions: 'إلغاء تحديد الكل',
    deleteBulkSessions: 'حذف ({n})',
    listSectionHeadingSessions: 'الجلسات',
    pageSliceSessions: 'عرض {start}–{end} من {total}',
    zeroSessionsLbl: '٠ جلسة',
    colSessionId: 'معرف الجلسة',
    colMember: 'العضو',
    colCheckIn: 'وقت الدخول',
    colCheckOut: 'وقت الخروج',
    colDuration: 'المدة',
    colStatusSessions: 'الحالة',
    colActionsSessions: 'إجراءات',
    sessionInProgress: 'قيد التنفيذ',
    optStatusActive: 'نشطة',
    optStatusCompleted: 'منتهية',
    optStatusCancelled: 'ملغاة',
    titleClickEditStatus: 'اضغط لتعديل الحالة',
    badgeStatusCompleted: 'منتهية',
    badgeStatusActive: 'نشطة',
    badgeStatusCancelled: 'ملغاة',
    titleViewDetails: 'عرض التفاصيل',
    titleEditSessions: 'تعديل',
    titleDeleteSessions: 'حذف',
    paginationAriaSessions: 'الترقيم',
    paginationPrevSessions: 'السابق',
    paginationNextSessions: 'التالي',
    bulkSessionsDeletedOk:
      'تم حذف {n} جلسة بنجاح',
    bulkSessionsDeleteFail: 'خطأ أثناء حذف الجلسات',
    confirmDeleteOneSessionRegular:
      'حذف هذه الجلسة بالتأكيد؟',
    statusUpdateFail: 'خطأ أثناء تحديث الحالة',
    bulkConfirmTitleSessions: 'تأكيد الحذف',
    bulkConfirmAskSessions:
      'حذف {n} جلسة بالتأكيد؟ لا يمكن التراجع عن هذا الإجراء.',
    bulkCancelSessions: 'إلغاء',
    bulkDeleteSessionsBtn: 'حذف',
    invalidTimeLabel: '-',
    timeInvalid: 'تاريخ غير صالح',
    trainingCardDateLbl: 'التاريخ',
    trainingCardScheduleLbl: 'الوقت',
    trainingCardPlaceLbl: 'المكان',
    trainingCardTrainerLbl: 'المكون',
    trainingCardDurationLbl: 'المدة',
    trainingCardSeatsLbl: 'المقاعد',
    trainingCardPriceLbl: 'السعر',
    trainingRelativeDone: 'منتهية',
    trainingRelativeToday: 'اليوم',
    trainingRelativeTomorrow: 'غدًا',
    trainingRelativeInDays: 'خلال {n} يومًا',
    trainingDurationHM: '{h}س {m}د',
    trainingDurationH: '{h}س',
    checkInSelectMemberToast: 'يرجى اختيار عضو',
    checkInNoActiveSessionErr: 'لا جلسة نشطة لهذا العضو',
    checkInOutOk: 'تم تسجيل الخروج بنجاح',
    checkInOk: 'تم تسجيل الدخول بنجاح',
    checkInSaveErr: 'خطأ أثناء التسجيل',
    checkInCameraErr: 'تعذّر الوصول إلى الكاميرا',
    subNoneLbl: 'لا اشتراك',
    subExpiredLbl: 'انتهى الاشتراك',
    subExpiresInDays: 'ينتهي خلال {n} يومًا',
    subActiveLbl: 'اشتراك نشط',
    subNoneFallback: 'لا يوجد',
    checkInWarnNoSubTitle: 'تنبيه: لا اشتراك نشط',
    checkInWarnNoSubBody: 'هذا العضو ليس لديه اشتراك نشط. هل تريد المتابعة؟',
    checkInWarnExpiredTitle: 'تنبيه: انتهى الاشتراك',
    checkInWarnExpiredBody: 'انتهى اشتراك هذا العضو في {date}. هل تريد المتابعة؟',
    checkInNotesPlaceholder: 'أضف ملاحظات عن هذه الجلسة…',
    checkInRegisterIn: 'تسجيل الدخول',
    checkInRegisterOut: 'تسجيل الخروج',
    checkInSearchPlaceholder: 'بحث عن عضو (اسم أو رمز)…',
    checkInQrBtn: 'مسح QR',
    checkInRecentActivity: 'نشاط حديث',
    unknownMember: 'عضو غير معروف',
    checkInPlaceholderSearchLong: 'بحث عن عضو (اسم، رمز، بريد، هاتف…)',
    checkInStopScanner: 'إيقاف',
    checkInScannerStart: 'مسح',
    checkInNoMembersFound: 'لا عضو. جرّب كلمات بحث أخرى.',
    phoneLblShort: 'الهاتف',
    subLblShort: 'الاشتراك',
    expiryLblShort: 'انتهاء',
    notesFieldLbl: 'ملاحظات (اختياري)',
    checkInToggleLbl: 'دخول',
    checkOutToggleLbl: 'خروج',
    checkInDurationHM: '{h}س {m}د',
    checkInDurationM: '{m}د',
    inRoomSince: 'في القاعة منذ {dur}',
    sessionsInProgressHeading: 'جلسات جارية ({n})',
    trainingDetailTitle: 'تفاصيل الجلسة',
    trainingTabDetails: 'التفاصيل',
    trainingTabResources: 'الموارد',
    trainingTabStudents: 'الطلاب',
    trainingStartDateLbl: 'تاريخ البداية',
    trainingEndDateLbl: 'تاريخ النهاية',
    trainingStartDateOptionalLbl: 'تاريخ البداية (اختياري)',
    trainingEndDateOptionalLbl: 'تاريخ النهاية (اختياري)',
    trainingTotalDurationLbl: 'المدة الإجمالية',
    trainingLocationLbl: 'المكان',
    trainingCapacityLbl: 'السعة',
    trainingTrainerLbl: 'المكون',
    trainingPriceLbl: 'السعر',
    trainingDescriptionLbl: 'الوصف',
    trainingPrerequisitesLbl: 'المتطلبات',
    trainingEquipmentLbl: 'المعدات المطلوبة',
    trainingNoResourcesTitle: 'لا توجد موارد',
    trainingNoResourcesBody: 'لم تُضف أي موارد تعليمية لهذه الجلسة.',
    trainingNoStudentsTitle: 'لا يوجد طلاب مسجَّلون',
    trainingNoStudentsBody: 'لا يوجد طلاب مسجَّلون في جلسة التكوين هذه.',
    trainingPlacesReservedLbl: 'مقاعد محجوزة',
    trainingPlacesReservedHeading: 'المقاعد المحجوزة',
    trainingStatusUpcoming: 'قادمة',
    trainingStatusInProgress: 'جارية',
    trainingStatusFinished: 'منتهية',
    trainingStatusUndefined: 'غير محدد',
    trainingStudentColName: 'الاسم',
    trainingStudentColStatus: 'الحالة',
    trainingStudentColEnrolled: 'تاريخ التسجيل',
    trainingStudentConfirmed: 'مؤكد',
  },

  classroomsPage: {
    notFound: 'القاعة غير موجودة',
    nameUndefined: 'لم يُذكر الاسم',
    codeUndefined: 'رمز غير محدّد',
    codeColon: 'الرمز:',
    lblType: 'النوع',
    capacitySuffix: '{n} طالبًا',
    lblFloorShort: 'الطابق',
    notSpecifiedFloor: 'غير محدد',
    equipment: 'التجهيزات',
    noEquipment: 'لا توجد تجهيزات',
    descriptionHeading: 'الوصف',
    featuresHeading: 'الميزات',
    projector: 'جهاز عرض',
    airConditioning: 'تكييف',
    computers: 'حواسيب',
    whiteboard: 'سبورة',
    available: 'متاحة',
    occupied: 'مشغولة',
    formTitleEdit: 'تعديل القاعة',
    formTitleAdd: 'إضافة قاعة',
    lblName: 'اسم القاعة',
    placeholderName: 'قاعة أ1، معمل حاسوب، إلخ',
    lblCode: 'الرمز',
    placeholderCode: 'S01، LAB-INFO، إلخ',
    lblTypeShort: 'النوع',
    selectType: 'اختر النوع',
    typeCourseRoom: 'قاعة درس',
    typeComputerLab: 'معمل معلوميات',
    typeConferenceRoom: 'قاعة مؤتمرات',
    typeWorkshop: 'ورشة عملية',
    lblCapacityShort: 'السعة',
    capacityPlaceholderStudents: 'عدد الطلاب',
    lblFloor: 'الطابق',
    floorPlaceholder: 'الأرضي، الأول، إلخ',
    lblStatusShort: 'الحالة',
    statusAvailableSelect: 'متاحة',
    statusOccupiedSelect: 'مشغولة',
    lblEquipmentCsv: 'التجهيزات',
    equipmentCsvPlaceholder: 'عرض، حاسوب، سبورة… (افصل بينها بفواصل)',
    lblDescriptionShort: 'الوصف',
    descriptionPlaceholder: 'ملاحظات أو وصف هذه القاعة…',
    featuresFormHeading: 'الميزات',
    cancelBtn: 'إلغاء',
    submitAdd: 'إضافة',
    submitUpdate: 'تحديث',
    saveError: 'حدث خطأ أثناء حفظ البيانات',
    confirmDelete: 'هل تريد حذف هذه القاعة بالتأكيد؟',
    deleteError: 'حدث خطأ أثناء الحذف',
    statRoomsTitle: 'القاعات',
    statRoomsHint: 'مسجّلة',
    statAvailableTitle: 'المتاحة',
    statAvailableHint: 'حالة حرة',
    statCapacityTitle: 'السعة',
    statCapacityHint: 'مقاعد تراكمية',
    availChipAvailable: 'المتاحة',
    availChipOccupied: 'المشغولة',
    clearSearchAria: 'مسح البحث',
    typeTabsAll: 'كل الأنواع',
    availTabsAll: 'كل الحالات',
    lblRoomTypeUpper: 'نوع القاعة',
    lblAvailUpper: 'التوفر',
    filtersActiveLbl: 'عوامل تصفية نشطة',
    resetBtn: 'إعادة الضبط',
    searchSr: 'ابحث عن قاعة',
    searchPlaceholder: 'اسم أو رمز أو نوع…',
    emptyTitle: 'لا توجد قاعات للعرض',
    emptyBody: 'عدِّل المرشّحات أو أضِف قاعة.',
    clearFiltersSearch: 'مسح التصفية والبحث',
    addRoom: 'إضافة قاعة',
    newRoomShortcut: 'قاعة جديدة',
    listHeading: 'قائمة القاعات',
    resultsSingular: 'نتيجة',
    resultsPlural: 'نتائج',
    rangeOn: 'النطاق',
    onTotal: 'من',
    perPage: 'لكل صفحة',
    placesShort: '{n} مقعدًا',
    unnamed: 'بلا اسم',
    paginationDisplay: 'عرض {range} من {total} · صفحة {page} من {pages}',
    tableColRoom: 'القاعة',
    tableColType: 'النوع',
    tableColCapacity: 'السعة',
    tableColFloor: 'الطابق',
    tableColStatus: 'الحالة',
    tableColActions: 'إجراءات',
    titleViewSr: 'عرض',
    titleEditSr: 'تعديل',
    titleDeleteSr: 'حذف',
    paginationAria: 'ترقيم الصفحات',
    paginationPrev: 'السابق',
    paginationNext: 'التالي',
    backToList: 'العودة إلى القائمة',
  },

  pageDescriptions: {
    sessions: 'إدارة جلسات التدريب والتكوين',
    classrooms: 'إدارة القاعات ومساحات التكوين',
    reports: 'اعرض وحلّل بيانات المدرسة',
    groups: 'أنشئ وأدر مجموعات الدورات مع المواعيد والمدرّبين',
    payments: 'إدارة المدفوعات والعمليات',
    evaluations: 'متابعة التقييمات حسب الوحدة والمتعلّم.',
    benefits: 'لوحة مالية ومؤشرات محدَّثة من الخادم (D1).',
    certifications: 'منح ومتابعة الدبلومات والشهادات والتوصيات',
    schedule: 'الجلسات والدورات والقاعات — عرض تقويم محدَّث تقريبًا لحظيًا.',
  },

  benefitsTabs: {
    overviewName: 'نظرة عامة مالية',
    overviewDesc: 'نظرة شاملة على المالية وإيرادات التكوين',
    teachersName: 'المدرّبون',
    teachersDesc: 'إدارة المدرّبين وأداءهم التربوي',
    revenueName: 'إيرادات التكوين',
    revenueDesc: 'تحليل الإيرادات حسب الدورات',
    expensesName: 'مصاريف تعليمية',
    expensesDesc: 'إدارة تكاليف التكوين والمعدات',
    devFallback: 'محتوى قيد التطوير',
  },

  certificationsPage: {
    statTotalTitle: 'إجمالي الشهادات',
    statTotalHint: 'جميع الأنواع',
    statIssuedTitle: 'مُصدَرة',
    statIssuedHint: 'بحالة الإصدار',
    statPendingTitle: 'قيد الانتظار',
    statPendingHint: 'لاستكمالها أو إصدارها',
    typeDiploma: 'دبلومات',
    typeCertification: 'شهادات',
    typeAttestation: 'توصيات',
    tabAll: 'كل الشهادات',
    tabIssued: 'مُصدَرة',
    tabPending: 'قيد الانتظار',
    tabDiploma: 'دبلومات',
    tabCertification: 'شهادات',
    tabAttestation: 'توصيات',
    emptyFiltered: 'لا توجد شهادات',
    deleteToastError: 'خطأ أثناء حذف الشهادة',
    confirmDeleteCert: 'هل تريد حذف هذه الشهادة بالتأكيد؟',
    deleteSuccessToast: 'تم حذف الشهادة بنجاح',
    notFoundDeleteToast: 'خطأ: الشهادة غير موجودة',
    newCertificateBtn: 'شهادة جديدة',
    backToList: 'العودة إلى القائمة',
    toastAddSuccess: 'تم إضافة الشهادة بنجاح',
    toastUpdateSuccess: 'تم تعديل الشهادة بنجاح',
  },

  evaluationsUi: {
    newEvaluationBtn: 'تقييم جديد',
    searchPlaceholder: 'ابحث حسب الطالب أو الوحدة أو المدرّب…',
    allModules: 'جميع الوحدات',
    confirmDeleteEvaluation: 'هل تريد حذف هذا التقييم بالتأكيد؟',
    emptyTitle: 'لم يتم العثور على تقييمات',
    emptyBody: 'لا يوجد تقييم مطابق للمعايير المحددة.',
    loading: 'جاري التحميل…',
    typeExam: 'امتحان',
    typeProject: 'مشروع',
    typeQuiz: 'اختبار قصير',
    statusPending: 'قيد الانتظار',
    statusCompleted: 'منتهية',
    evalDateLabel: 'تاريخ التقييم',
    scoreOutOfLabel: 'من',
    studentLabel: 'الطالب',
    moduleLabel: 'الوحدة',
    dateLabel: 'التاريخ',
    scoreLabel: 'النتيجة',
    commentsSection: 'التعليقات',
    strengthsLabel: 'نقاط القوة',
    improvementsLabel: 'نقاط للتحسين',
    recommendationsLabel: 'التوصيات',
    evaluatedByLabel: 'قيم بواسطة',
    noCommentLabel: 'لا يوجد تعليق',
    detailsBtn: 'التفاصيل',
    selectModule: 'اختر وحدة',
    selectStudent: 'اختر طالباً',
    studentNameLabel: 'اسم الطالب',
    evalTypeLabel: 'نوع التقييم',
  },

  reportsPage: {
    goToPayments: 'انتقل إلى صفحة المدفوعات لإضافة معاملات',
    dataWillAppear: 'ستظهر البيانات تلقائياً هنا بمجرد إضافة المدفوعات',
    periodCol: 'الفترة',
    activeStudentsOnly: 'الطلاب النشطون فقط',
    reportTypeLabel: 'نوع التقرير',
    periodLabel: 'الفترة',
    startDateLabel: 'تاريخ البداية',
    endDateLabel: 'تاريخ النهاية',
    financialReportTitle: 'التقرير المالي',
    financialReportDesc: 'نظرة عامة على الإيرادات والمصروفات والأرباح',
    periodDisplay: 'فترة مخصصة',
    financialSummary: 'ملخص مالي',
    newStudents: 'طلاب جدد',
    activeStudentsLabel: 'الطلاب النشطون',
    inactiveStudents: 'الطلاب غير النشطين',
    totalStudents: 'إجمالي الطلاب',
    waitForData: 'يرجى الانتظار حتى تحميل البيانات قبل التصدير',
    noRevenueData: 'لا توجد بيانات إيرادات',
    revenueCol: 'الإيرادات',
    expensesCol: 'المصروفات',
    profitCol: 'الربح',
    loadingFinancialData: 'جاري تحميل البيانات المالية...',
    loadingData: 'جاري تحميل البيانات...',
    noCourseAvailable: 'لا توجد دورات متاحة',
    createCourseHint: 'أنشئ دورات في قسم الدورات لعرض التوزيع',
    noFinancialDataAvailable: 'لا توجد بيانات مالية متاحة',
    noStudentDataAvailable: 'لا توجد بيانات طلاب متاحة',
    noCourseDataAvailable: 'لا توجد بيانات دورات متاحة',
    noSalesDataAvailable: 'لا توجد بيانات مبيعات متاحة',
  },

  common: {
    none: 'لا شيء',
    noneF: 'لا شيء',
    notSpecified: 'غير محدد',
    notSpecifiedF: 'غير محددة',
    noDataAvailable: 'لا توجد بيانات متاحة',
    noPaymentFound: 'لم يتم العثور على دفعات',
    noPaymentMatchCriteria: 'لا توجد دفعات تطابق معايير البحث.',
    noPaymentRecorded: 'لا توجد دفعات مسجلة حالياً.',
    noCourseFound: 'لم يتم العثور على دورات',
    noTrainerFound: 'لم يتم العثور على مدربين',
    noRoomFound: 'لم يتم العثور على قاعات',
    noStudentFound: 'لم يتم العثور على طلاب',
    noEvaluationFound: 'لم يتم العثور على تقييمات',
    noSessionFound: 'لم يتم العثور على جلسات',
    noGroupFound: 'لم يتم العثور على مجموعات',
    noNotification: 'لا توجد إشعارات',
    noNotificationMatchCriteria: 'لا توجد إشعارات تطابق المعايير المحددة.',
    noNewNotification: 'لا توجد إشعارات جديدة',
    noUnreadNotification: 'لا توجد إشعارات غير مقروءة',
    noPlanSelected: 'لم يتم اختيار خطة',
    noPlan: 'لا توجد خطة',
    noBioAvailable: 'لا يوجد سيرة ذاتية متاحة',
    noExpense: 'لا توجد مصروفات',
    noExpenseThisMonth: 'لا توجد مصروفات هذا الشهر',
    noResourceAdded: 'لم تتم إضافة موارد',
    noResourceAvailable: 'لا توجد موارد متاحة',
    noResourceDescription: 'لم تتم إضافة أي موارد تعليمية لهذه الجلسة.',
    noStudentEnrolledSession: 'لا يوجد طلاب مسجلون في جلسة التدريب هذه.',
    noActiveSubscription: 'لا يوجد اشتراك نشط',
    noSubscriptionFound: 'لم يتم العثور على اشتراكات',
    noSubscriptionMatchCriteria: 'لا توجد اشتراكات تطابق معايير البحث.',
    noActiveSubscriptionNow: 'لا يوجد اشتراك نشط حالياً.',
    noProgramAssigned: 'لا توجد برامج مخصصة',
    noCoachFound: 'لم يتم العثور على مدربين',
    noExerciseFound: 'لم يتم العثور على تمارين',
    noPlanFound: 'لم يتم العثور على خطط',
    noTemplateConfigured: 'لم يتم تكوين قالب',
    emailNotificationEnabled: 'سيتم إرسال الإشعارات عبر البريد الإلكتروني',
    emailNotificationDisabled: 'لن يتم إرسال أي إشعارات عبر البريد الإلكتروني',
    smsNotificationEnabled: 'سيتم إرسال الإشعارات العاجلة عبر الرسائل القصيرة',
    smsNotificationDisabled: 'لن يتم إرسال أي إشعارات عبر الرسائل القصيرة',
    days: 'أيام',
    selectedPlan: 'الخطة المختارة',
    duration: 'المدة',
    add: 'إضافة',
    addExpense: 'إضافة مصروف',
    addTrainer: 'إضافة مدرب',
    addCoach: 'إضافة مدرب رياضي',
    addExercise: 'إضافة تمرين',
    addCategory: 'إضافة فئة',
    addCourseType: 'إضافة نوع دورة',
    addEquipment: 'إضافة معدات',
    addMember: 'إضافة عضو',
    addPlan: 'إضافة خطة',
    addFeature: 'إضافة ميزة',
    saveChanges: 'حفظ التغييرات',
    print: 'طباعة',
    exportPDF: 'تصدير PDF',
    exportExcel: 'تصدير Excel',
    printTitle: 'طباعة',
    exportPDFTitle: 'تصدير PDF',
    exportExcelTitle: 'تصدير Excel',
    closeBtn: 'إغلاق',
    confirmTitle: 'تأكيد',
    confirmBtn: 'تأكيد',
    cancelBtn: 'إلغاء',
    update: 'تحديث',
    create: 'إنشاء',
    search: 'بحث',
    searchPlaceholder: 'بحث...',
    paymentDetails: 'تفاصيل الدفع',
    amountDetails: 'تفاصيل المبلغ',
    editPayment: 'تعديل الدفع',
    newPayment: 'دفع جديد',
    editMember: 'تعديل العضو',
    newMember: 'عضو جديد',
    updateMemberInfo: 'تحديث معلومات العضو',
    addNewMember: 'إضافة عضو جديد إلى النادي',
    updateBtn: 'تحديث',
    createBtn: 'إنشاء',
    member: 'عضو',
    editExercise: 'تعديل التمرين',
    newExercise: 'تمرين جديد',
    editPlan: 'تعديل',
    newPlan: 'إنشاء',
    trainingSession: 'خطة تدريب',
    thePlan: 'الخطة',
    editCoach: 'تعديل المدرب الرياضي',
    newCoach: 'إضافة مدرب رياضي',
    updateCoach: 'تحديث',
    addCoachBtn: 'إضافة المدرب الرياضي',
    newTrainingSession: 'جلسة تدريب جديدة',
    editTrainingSession: 'تعديل جلسة التدريب',
    createSession: 'إنشاء الجلسة',
    updateSession: 'تحديث',
    noProgramAssigned: 'لا توجد برامج مخصصة',
    editSubscription: 'تعديل',
    newSubscription: 'إنشاء',
    plan: 'خطة',
    subscription: 'اشتراك',
    theSubscription: 'الاشتراك',
    viewDetails: 'عرض التفاصيل',
    sessionDetails: 'تفاصيل الجلسة',
    memberDetails: 'تفاصيل العضو',
    notificationDetails: 'تفاصيل الإشعار',
    all: 'عرض الكل',
    unread: 'عرض غير المقروء',
    paymentReceipt: 'إيصال الدفع',
  },
};
